import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  loadRapportSousSystemesAction,
  loadRapportSousSystemesSuccessAction,
  getIsRapportSousSystemeInitialized,
  RapportSousSystemeState,
  loadRapportSousSystemesErrorAction,
} from './rapport-sous-systeme.store';
import { RapportSousSystemeService } from '../../_services/http/rapport-sous-systeme.service';

@Injectable()
export class RapportSousSystemeEffect {
  constructor(
    private service: RapportSousSystemeService,
    private actions$: Actions,
    private store: Store<RapportSousSystemeState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRapportSousSystemesAction),
      withLatestFrom(this.store.select(getIsRapportSousSystemeInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadRapportSousSystemesSuccessAction({ payload })),
          catchError(() => of(loadRapportSousSystemesErrorAction()))
        )
      )
    )
  );
}
